<template lang="pug">
    div    
        form-insert(:IsShowModal.sync="IsShowModalInsert",:tableListSelect.sync="tableListSelect",:tablePending.sync="tablePending",:tableListExpressionRegulate.sync="tableListExpressionRegulate",:nameModulo="nameModulo",:parameter.sync="parameterInsert", @sendInfo="val => Insert(val)")
        form-update(:IsShowModal.sync="IsShowModalUpdate",:tableListSelect.sync="tableListSelect",:tableListExpressionRegulate.sync="tableListExpressionRegulate",:nameModulo="nameModulo",:parameter.sync="parameterUpdate", @sendInfo="val => Update(val)")         
        v-container( fluid)
            v-btn(color="primary" @click="IsShowModalInsert=true") AGREGAR ITEM
                                    i.fa.fa-plus-circle
        div(v-show="false") {{IdDocCategory_}}            
        v-container( fluid)
            form-view(:parameter.sync="parameterView",:tablaInfo.sync="tableInfo",@changeOrder="val => UpdateOrderFieldDoc(val)" @sendSearch="val => List_Info(val)", @sendInfo="val => {IsShowModalUpdate=true,parameterUpdate=val}",@sendInfoDinamic="val => {IsShowModalConfig=true,ItemSelect=val}" ) 

</template>
<script>  
import model from "../../../models/docField.js" 
import modelListSelect from "../../../models/docListSelect" 
import formInsert from './components/insert.vue'
import formUpdate from './components/update.vue'
import formView from './components/view.vue'
export default {
    props:{
        apiWeb:Object,
        IdDocType:Number,
        IdEnterprise:Number,
        InfoCategory:Object
    },
    components:{
                formInsert,
                formUpdate,
                formView
    },    
    data(){
        return{ 
                nameModulo:'Items Documento',
                pathApi:'DocField/DocField', 
                IsShowModalInsert:false,
                IsShowModalUpdate:false, 
                ItemSelect:{},
                parameterUpdate:Object.assign({}, model.parameterUpdate),
                parameterInsert:Object.assign({}, model.parameterInsert),
                parameterView:Object.assign({}, model.parameterCategoryView),
                parameterListView:Object.assign({}, modelListSelect.parameterView),
                tableInfo:[],
                tablePending:[],
                tableListSelect:[],
                tableListExpressionRegulate:[],
                IdDocCategoryOldValue:0,
        }
    },
    computed:{ 
        IdDocCategory_ :{
                        get(){
                            if(this.IdDocCategoryOldValue!=this.InfoCategory.IdDocCategory){
                                this.IdDocCategoryOldValue=this.InfoCategory.IdDocCategory
                                this.List_Info()  
                                this.List_Pending()                          
                            }                                
                            return this.InfoCategory.IdDocCategory
                        },
                        set(val){ 
                            this.$emit("update:InfoCategory.IdDocCategory",val) 
                        }
            
        } 
    },
    mounted(){ 
        this.List_Info()
        this.List_Pending()  
        this.List_ListSelect() 
        this.List_ExpressionRegulate()
    },
    methods:{
        List_ListSelect(){
            this.parameterListView.IdEnterprise=this.IdEnterprise
            this.apiWeb.post("DocListSelect/DocListSelect_View",this.parameterListView)
                    .then(result=>{
                                if(result.status==0){
                                    this.tableListSelect=JSON.parse(result.value) 
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },  
        List_ExpressionRegulate(){
             
            this.apiWeb.get("RegulateExpression/RegulateExpressionList",this.IdEnterprise)
                    .then(result=>{
                                if(result.status==0){
                                    this.tableListExpressionRegulate=JSON.parse(result.value) 
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },  
        List_Info(){
            this.parameterView.IdDocCategory=this.IdDocCategory_
            this.apiWeb.post(this.pathApi + "Category_View",this.parameterView)
                    .then(result=>{
                                if(result.status==0){
                                    this.tableInfo=JSON.parse(result.value) 
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        UpdateOrderFieldDoc(parameters){
            console.log(parameters)
            this.apiWeb.post(this.pathApi + "_ChangeOrder",parameters)
                    .then(result=>{
                                if(result.status==0){
                                     this.List_Info()
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        List_Pending(){
            this.parameterView.IdDocCategory=this.IdDocCategory_
            this.apiWeb.post(this.pathApi + "Category_Pending",this.parameterView)
                    .then(result=>{
                                if(result.status==0){
                                    this.tablePending=JSON.parse(result.value) 
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        Insert(){
            this.parameterInsert.IdDocType=this.IdDocType
            this.parameterInsert.User=this.$info.email
            this.parameterInsert.IP=this.$info.ip
            this.parameterInsert.IdDocCategory=this.IdDocCategory_
            this.parameterInsert.FieldLevel2=2
            this.apiWeb.post(this.pathApi +"_Insert",this.parameterInsert)
                    .then(result=>{ 
                            if(result.status==0){
                                this.List_Info()
                                this.List_Pending()
                                this.IsShowModalInsert=false
                                this.parameterInsert=Object.assign({}, model.parameterInsert)
                                this.parameterInsert.IdEnterprise=this.selectEnterprise
                                this.$msgbox.show("Ingresado","Notificacion")
                            }
                            else{
                                this.$msgbox.show(result.message,"Error nivel 1")
                            }

                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        Update(){
 
            this.parameterUpdate.User=this.$info.email
            this.parameterUpdate.IP=this.$info.ip
            this.apiWeb.post(this.pathApi + "_Update",this.parameterUpdate)
                    .then(result=>{ 
                             if(result.status==0){
                                this.List_Info()
                                this.IsShowModalUpdate=false
                                this.$msgbox.show("Actualizado","Notificacion")
                            }
                            else{
                               this.$msgbox.show(result.message,"Error nivel 1")
                            }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        }
    }
}
</script>